import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import Badges from './Badges';
import Group from '../Group/Group';
import Icon from '../Icon/Icon';

class BadgesExample extends Component {

  state = {
    iconNames: ['link', 'lock', 'notification'],
    label: 'Draft',
    labels: ['mobile', 'tablet', 'web'],
  };

  onChange = e => this.setState(e.target.value);

  render() {
    return (
      <Example {...this.props}>
        <Properties onChange={this.onChange} defaultProps={Badges.defaultProps} propTypes={Badges.propTypes} propValues={this.state}/>
        <Group>
          <Badges {...this.state}/>
          <Badges label="Custom icons" iconNames={this.state.iconNames}>
            <Icon name="warning" className="warning" title="Asset is not published"/>
          </Badges>
          <Badges label={this.state.label}/>
          <Badges iconNames={this.state.iconNames}/>
        </Group>
        <SourceCode querySelector=".badges-example .core-badges"/>
      </Example>
    );
  }

}

BadgesExample.tags = 'tags';

export default BadgesExample;
